import '../App.css';

export default function About() {


  return (
    <div className="App">
      <header className="App-header">
        <p>
          A band that sounds like a band.  from the Twin Cities.
        </p>
      </header>
    </div>
  );
}